// extracted by mini-css-extract-plugin
export default {"imgHeight":"articleDetails_imgHeight__wExW0","content":"articleDetails_content__YQ2aH"};